// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class RangeSlider extends Vue {
  slider;

  @Prop({ default: [] })
  values!: Array<number>;

  slidePositions: number[] = [];
  leftPosition = 0;
  isMovingLeft = false;
  isMovingRight = false;
  portionHalf = 0;

  leftOffset = 0;
  leftIndex = 0;
  rightOffset = 0;
  rightIndex = 0;

  created() {
    window.addEventListener("resize", this.handleResize);
  }

  mounted() {
    this.slider = <HTMLElement>this.$refs["sliderarea"];
    let slidearea = this.slider.getBoundingClientRect().width;
    this.leftPosition = this.slider.getBoundingClientRect().left;

    if (this.values.length > 1) {
      for (let i = 0; i < this.values.length; i++) {
        let positionValue = i * (slidearea / (this.values.length - 1));
        this.slidePositions.push(Math.floor(positionValue));
      }
      this.portionHalf = this.slidePositions[1] / 2;
    }
  }

  @Watch("values")
  private init() {
    this.slidePositions = [];
    this.leftPosition = 0;
    this.portionHalf = 0;

    this.leftOffset = 0;
    this.leftIndex = 0;
    this.rightOffset = 0;
    this.rightIndex = 0;

    let slidearea = this.slider.getBoundingClientRect().width;
    this.leftPosition = this.slider.getBoundingClientRect().left;

    if (this.values.length > 1) {
      for (let i = 0; i < this.values.length; i++) {
        let positionValue = i * (slidearea / (this.values.length - 1));
        this.slidePositions.push(Math.floor(positionValue));
      }
      this.portionHalf = this.slidePositions[1] / 2;
    }
  }

  get valuesLength() {
    return this.values.length;
  }

  get trackStyle() {
    let minValue = this.values[this.leftIndex];
    let maxValue = this.values[this.values.length - this.rightIndex - 1];
    if (minValue > maxValue) {
      let trackLeft =
        this.slidePositions[this.values.length - this.rightIndex - 1];
      let trackRight =
        this.slidePositions[this.values.length - this.leftIndex - 1];
      return "left: " + trackLeft + "px;  right: " + trackRight + "px;";
    }
    return (
      "left: " + this.leftOffset + "px;  right: " + this.rightOffset + "px;"
    );
  }

  get valuesLengthClass() {
    let itemClass = "";
    switch (this.values.length) {
      case 2:
        itemClass = "__legend-item--two";
        break;

      case 3:
        itemClass = "__legend-item--three";
        break;

      case 4:
        itemClass = "__legend-item--four";
        break;

      case 5:
        itemClass = "__legend-item--five";
        break;

      case 6:
        itemClass = "__legend-item--six";
        break;

      default:
        itemClass = "__legend-item--more";
        break;
    }
    return itemClass;
  }

  private handleResize() {
    let slidearea = this.slider.getBoundingClientRect().width;
    this.leftPosition = this.slider.getBoundingClientRect().left;
    this.slidePositions = [];

    if (this.values.length > 1) {
      for (let i = 0; i < this.values.length; i++) {
        let positionValue = i * (slidearea / (this.values.length - 1));
        this.slidePositions.push(Math.floor(positionValue));
      }
      this.portionHalf = this.slidePositions[1] / 2;
    }

    this.leftOffset = this.slidePositions[this.leftIndex];
    this.rightOffset = this.slidePositions[this.rightIndex];
  }

  private mousedown(side, $event) {
    $event.preventDefault();
    if (side == "left") {
      this.isMovingLeft = true;
    } else if (side == "right") {
      this.isMovingRight = true;
    }
    window.addEventListener("mousemove", this.thumbMove);
    window.addEventListener("mouseup", this.mouseup);
  }

  private mouseup() {
    this.isMovingLeft = false;
    this.isMovingRight = false;
    window.removeEventListener("mousemove", this.thumbMove);
    window.removeEventListener("mouseup", this.mouseup);
    this.returnValues();
  }

  private thumbMove($event) {
    if (this.isMovingLeft === true) {
      if ($event.clientX < this.leftPosition + this.portionHalf) {
        this.leftOffset = this.slidePositions[0];
        this.leftIndex = 0;
      } else if (
        $event.clientX >
        this.leftPosition +
          this.portionHalf * (2 * this.slidePositions.length - 3)
      ) {
        this.leftOffset = this.slidePositions[this.slidePositions.length - 1];
        this.leftIndex = this.slidePositions.length - 1;
      } else {
        for (let i = 1; i < this.slidePositions.length - 1; i++) {
          if (
            $event.clientX >
              this.leftPosition + this.portionHalf * (2 * i - 1) &&
            $event.clientX < this.leftPosition + this.portionHalf * (2 * i + 1)
          ) {
            this.leftOffset = this.slidePositions[i];
            this.leftIndex = i;
          }
        }
      }
    } else if (this.isMovingRight === true) {
      if ($event.clientX < this.leftPosition + this.portionHalf) {
        this.rightOffset = this.slidePositions[this.slidePositions.length - 1];
        this.rightIndex = this.slidePositions.length - 1;
      } else if (
        $event.clientX >
        this.leftPosition +
          this.portionHalf * (2 * this.slidePositions.length - 3)
      ) {
        this.rightOffset = this.slidePositions[0];
        this.rightIndex = 0;
      } else {
        for (let i = 1; i < this.slidePositions.length - 1; i++) {
          if (
            $event.clientX >
              this.leftPosition + this.portionHalf * (2 * i - 1) &&
            $event.clientX < this.leftPosition + this.portionHalf * (2 * i + 1)
          ) {
            this.rightOffset =
              this.slidePositions[this.slidePositions.length - i - 1];
            this.rightIndex = this.slidePositions.length - i - 1;
          }
        }
      }
    }
  }

  public returnValues() {
    let minValue = this.values[this.leftIndex];
    let maxValue = this.values[this.values.length - this.rightIndex - 1];
    if (minValue > maxValue) {
      this.$emit("input", { min: maxValue, max: minValue });
    } else {
      this.$emit("input", { min: minValue, max: maxValue });
    }
  }
}
